import { useEffect, useState } from 'react'

export const useListenLocalStorage = (
  arrayProps: string[]
): Record<string, any> => {
  const [localStorageValues, setLocalStorageValues] = useState(
    arrayProps.reduce((acc, cur) => {
      return {
        ...acc,
        [cur]: localStorage.getItem(cur),
      }
    }, {})
  )
  useEffect(() => {
    const localStorageChangeEvents = (): void => {
      arrayProps.forEach((key) => {
        const value = localStorage.getItem(key)
        setLocalStorageValues({
          ...localStorageValues,
          [key]: value,
        })
      })
    }

    window.addEventListener('storage', localStorageChangeEvents, false)

    return () => window.removeEventListener('storage', localStorageChangeEvents)
  }, [])

  return localStorageValues
}
